<template>
  <div class="contacts-block">
    <span class="title">{{ vacancy.name }}</span>
    <span class="archive-label" v-if="!vacancy.is_active">
      {{$tr('vacancies.archiveLabel')}}
    </span>
    <i>|</i>
    <a :href="'mailto:' + candidate.email">{{ candidate.email }}</a>
    <i>|</i>
    <span>{{ candidate.phone }}</span>
     <template v-if="taskLink">
      <i>|</i>
      <span><a :href="taskLink">{{ $tr('responses.downloadBusinessPlan') }}</a></span>
    </template>
  </div>
</template>

<script>
  import MixinState from '../../../mixins/state.js'

  export default {
    name: 'process-response-blocks-block-contacts',

    mixins: [
      MixinState
    ],

    props: {
      candidate: {
        type: Object,
        default: {}
      },
      vacancy: {
        type: Object,
        default: {}
      }
    },

    computed: {
      // storeResponseDataBatChampionship lives in mixin
      taskLink () {
        return this.storeResponseDataBatChampionship ? this.storeResponseDataBatChampionship.file_url : null
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../../styles/components/response/blocks/BlockContacts.scss";
</style>
